import { KiteIcon } from '@kite/react-kite';
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image';
import React from 'react';
import './TaggedImage.scss';

export interface TaggedImageProps {
    /** Background of the image tag. */
    bg: `white` | `dark`;
    /** Placement of the image tag */
    placement: `left` | `right`;
    /** The image to be displayed. */
    image: IGatsbyImageData;
    /** The image alt text. */
    imageAlt?: string;
    /** The tag to be displayed. */
    tag?: {
        /** A small image displayed in the tag. */
        image?: IGatsbyImageData;
        /** Text to be displayed in the tag, with optional icon. */
        body?: {
            text?: string;
            icon?: string;
        };
        /** Smaller text to be displayed in the tag. */
        caption?: string;
    };
    /** Whether to round the container. This also forces the aspect ratio.  */
    rounded?: boolean;
}

export const TaggedImage = (props: TaggedImageProps) => {
    return (
        <figure className={`tagged-image ${props.rounded ? `rounded` : ``}`}>
            <GatsbyImage
                image={props.image}
                alt={props.imageAlt ? props.imageAlt : ``}
            />
            {props.tag && (
                <figcaption
                    className={`${props.placement} ${
                        props.bg !== `white` ? `dark` : `light`
                    }`}
                >
                    {props.tag.image && (
                        <GatsbyImage
                            image={props.tag.image}
                            objectFit="scale-down"
                            alt=""
                        />
                    )}
                    {props.tag.body && (
                        <span>
                            {props.tag.body.icon && (
                                <KiteIcon icon={props.tag.body.icon} />
                            )}
                            {props.tag.body.text}
                        </span>
                    )}
                    {props.tag.caption && <p>{props.tag.caption}</p>}
                </figcaption>
            )}
        </figure>
    );
};
